module.exports = __webpack_public_path__ + "img/CM-DJ-26-Nissan-Playful.fba2b25c.jpg";